import React from "react";
import './internalFooters.css'
function Footer() {
  return (
    <div className="footerUser">
      <span>
        If you have any inquiries, please feel free to contact us at{" "}
        <a href={`mailto:${process.env.REACT_APP_ADMIN_EMAIL}`}>
          {process.env.REACT_APP_ADMIN_EMAIL}
        </a>
      </span>
      <br />
      <div className="container">
        <div id="footer-info">
          © 2023 DataToBiz
          <span className="trademark">
            <sup>TM</sup>
          </span>{" "}
          All Rights Reserved
        </div>
      </div>
    </div>
  );
}

export default Footer;
